// /registro → pantalla unificada de acceso y registro, pestaña «Crear cuenta».
import Auth from "@/pages/Auth";

export default function Register() {
  return <Auth tab={1} />;
}
